import { apiGateway } from "@/shared/apiGateway";

const getPlantsWithoutStatInspListing = (
  context,
  { filterCriteria, searchCriteria }
) => {
  var url = "api/statutoryInspections/plants-without-stat-insp";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.contractorRegionId !== "0") {
    url = url + "&contractorRegionId=" + filterCriteria.contractorRegionId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDPLANTSWITHOUTSTATINSP", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting plants without Stat. Insp."],
        { root: true }
      );
    });
};

const getStatInspListing = (context, { filterCriteria, searchCriteria }) => {
  var url = "api/statutoryInspections";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.contractorRegionId !== "0") {
    url = url + "&contractorRegionId=" + filterCriteria.contractorRegionId;
  }
  if (filterCriteria.statInspStatusId !== 0) {
    url = url + "&statInspStatus=" + filterCriteria.statInspStatusId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDSTATINSPS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Statutory Inspections"],
        {
          root: true
        }
      );
    });
};

const getStatInsp = (context, statInspId) => {
  return apiGateway
    .apiGatewayGET("api/statutoryInspections/" + statInspId)
    .then(data => {
      context.commit("STATINSP_SETSTATINSP", data);
      context.commit("STATINSP_UPDATESTATINSPITEMS", data.statInspItems);
    })
    .catch(error => {
      console.error(error);
      context.commit("STATINSP_SETSTATINSP", undefined);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Stat. Insp. - " + error.response.data],
        {
          root: true
        }
      );
    });
};

const getStatInspItemDetail = (context, statInspItemId) => {
  return apiGateway
    .apiGatewayGET(
      "api/statutoryInspections/get-stat-insp-item/" + statInspItemId
    )
    .then(data => {
      context.commit("STATINSP_SETSTATINSPITEM", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat. Insp. item"], {
        root: true
      });
    });
};

const getPagedStatInspItems = (context, { filterCriteria, searchCriteria }) => {
  var url = "api/statutoryInspections/paged-stat-insp-items";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.contractorRegionId !== "0") {
    url = url + "&contractorRegionId=" + filterCriteria.contractorRegionId;
  }
  url = url + "&statInspItemStatus=" + filterCriteria.statInspItemStatusId;
  if (filterCriteria.statInspItemTypeId !== 0) {
    url = url + "&statInspItemType=" + filterCriteria.statInspItemTypeId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEPAGESSTATINSPITEMS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat Insp Items"], {
        root: true
      });
    });
};

const getChargeableStatInspItems = (
  context,
  { filterCriteria, searchCriteria }
) => {
  var url = "api/statutoryInspections/chargeable-stat-insp-items";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  url = url + "&withQuote=" + filterCriteria.withQuote;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.contractorRegionId !== "0") {
    url = url + "&contractorRegionId=" + filterCriteria.contractorRegionId;
  }
  if (filterCriteria.statInspItemTypeId !== 0) {
    url = url + "&statInspItemType=" + filterCriteria.statInspItemTypeId;
  }

  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEPAGESSTATINSPITEMS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat Insp Items"], {
        root: true
      });
    });
};

export default {
  getStatInsp,
  getStatInspItemDetail,
  getStatInspListing,
  getPagedStatInspItems,
  getPlantsWithoutStatInspListing,
  getChargeableStatInspItems
};
